/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType = Types.Exact<{
  worklease: Types.ReportingGenerateWorkleaseGQLType;
}>;


export type GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType = (
  { __typename?: 'Query' }
  & { inputConfig: (
    { __typename?: 'EvaluatedReportingInputConfig' }
    & Pick<Types.EvaluatedReportingInputConfigGQLType, 'errors'>
    & { variables: Array<(
      { __typename?: 'ReportingVariable' }
      & Pick<Types.ReportingVariableGQLType, 'name' | 'value'>
    )> }
  ) }
);

export type GetAllComplianceReportCfsByCfIdQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetAllComplianceReportCfsByCfIdQueryGQLType = (
  { __typename?: 'Query' }
  & { reports: Array<(
    { __typename?: 'ComplianceReportCfScoped' }
    & Pick<Types.ComplianceReportCfScopedGQLType, 'id' | 'creditFacilityId' | 'creditAgreementId' | 'reportName' | 'reportType' | 'isPreview' | 'reportingDate' | 'version'>
  )> }
);

export type GetComplianceReportCfS3DownloadUrlQueryVariablesGQLType = Types.Exact<{
  complianceReportId: Types.Scalars['UUID'];
}>;


export type GetComplianceReportCfS3DownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrl: Types.QueryGQLType['getComplianceReportCfS3DownloadUrl'] }
);

export type GetReportingTemplateDownloadUrlQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
  templateName: Types.Scalars['String'];
  s3Path: Types.Scalars['String'];
}>;


export type GetReportingTemplateDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrl: Types.QueryGQLType['getReportingTemplateDownloadUrl'] }
);

export type InsertNewReportingTemplateMutationVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
  baseOutputFilename: Types.Scalars['String'];
  reportType: Types.ReportConfigTypeGQLType;
  templateName: Types.Scalars['String'];
  s3Path: Types.Scalars['String'];
}>;


export type InsertNewReportingTemplateMutationGQLType = (
  { __typename?: 'Mutation' }
  & { newTemplate: (
    { __typename?: 'BaseReportTemplate' }
    & Pick<Types.BaseReportTemplateGQLType, 'id' | 'creditFacilityId' | 'templateName' | 'isActive' | 'reportType' | 's3Path' | 'baseOutputFilename' | 'created_at' | 'updated_at'>
  ) }
);

export type CreateComplianceReportCfRecordMutationVariablesGQLType = Types.Exact<{
  creditAgreementId?: Types.Maybe<Types.Scalars['UUID']>;
  creditFacilityId: Types.Scalars['UUID'];
  reportName: Types.Scalars['String'];
  reportType: Types.ComplianceReportCfTypeGQLType;
  reportingDate: Types.Scalars['FullDateStr'];
  version: Types.Scalars['Int'];
  isPreview: Types.Scalars['Boolean'];
  database: Types.DatabaseGQLType;
  namespace: Types.Scalars['String'];
  identifier: Types.Scalars['String'];
}>;


export type CreateComplianceReportCfRecordMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createComplianceReportCfRecord: (
    { __typename?: 'ComplianceReportCfScoped' }
    & Pick<Types.ComplianceReportCfScopedGQLType, 'id' | 'creditFacilityId' | 'creditAgreementId' | 'reportName' | 'reportType' | 'reportingDate' | 'version'>
  ) }
);

export type ProduceReportingGenerateMessageMutationVariablesGQLType = Types.Exact<{
  worklease: Types.ReportingGenerateWorkleaseGQLType;
}>;


export type ProduceReportingGenerateMessageMutationGQLType = (
  { __typename?: 'Mutation' }
  & { result: (
    { __typename?: 'ReportingGenerateResponse' }
    & Pick<Types.ReportingGenerateResponseGQLType, 'status'>
  ) }
);

export type GenerateReportingOutputXlsxFileMutationVariablesGQLType = Types.Exact<{
  worklease: Types.ReportingGenerateWorkleaseGQLType;
}>;


export type GenerateReportingOutputXlsxFileMutationGQLType = (
  { __typename?: 'Mutation' }
  & { result: (
    { __typename?: 'ReportingGenerateResponse' }
    & Pick<Types.ReportingGenerateResponseGQLType, 'status'>
  ) }
);


export const GetEvaluatedReportInputConfigResultByCreditAgreementIdDocumentGQLType = gql`
    query GetEvaluatedReportInputConfigResultByCreditAgreementId($worklease: ReportingGenerateWorklease!) {
  inputConfig: getEvaluatedReportingInputConfigByCreditAgreementId(
    worklease: $worklease
  ) {
    variables {
      name
      value
    }
    errors
  }
}
    `;

/**
 * __useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery__
 *
 * To run a query within a React component, call `useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery({
 *   variables: {
 *      worklease: // value for 'worklease'
 *   },
 * });
 */
export function useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery(baseOptions: Apollo.QueryHookOptions<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>(GetEvaluatedReportInputConfigResultByCreditAgreementIdDocumentGQLType, options);
      }
export function useGetEvaluatedReportInputConfigResultByCreditAgreementIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>(GetEvaluatedReportInputConfigResultByCreditAgreementIdDocumentGQLType, options);
        }
export type GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryHookResult = ReturnType<typeof useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery>;
export type GetEvaluatedReportInputConfigResultByCreditAgreementIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEvaluatedReportInputConfigResultByCreditAgreementIdLazyQueryGQLType>;
export type GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryResultGQLType = Apollo.QueryResult<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>;
export const GetAllComplianceReportCfsByCfIdDocumentGQLType = gql`
    query GetAllComplianceReportCfsByCfId($creditFacilityId: UUID!) {
  reports: getAllComplianceReportCfsByCfId(creditFacilityId: $creditFacilityId) {
    id
    creditFacilityId
    creditAgreementId
    reportName
    reportType
    isPreview
    reportingDate
    version
  }
}
    `;

/**
 * __useGetAllComplianceReportCfsByCfIdQuery__
 *
 * To run a query within a React component, call `useGetAllComplianceReportCfsByCfIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllComplianceReportCfsByCfIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllComplianceReportCfsByCfIdQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetAllComplianceReportCfsByCfIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllComplianceReportCfsByCfIdQueryGQLType, GetAllComplianceReportCfsByCfIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllComplianceReportCfsByCfIdQueryGQLType, GetAllComplianceReportCfsByCfIdQueryVariablesGQLType>(GetAllComplianceReportCfsByCfIdDocumentGQLType, options);
      }
export function useGetAllComplianceReportCfsByCfIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllComplianceReportCfsByCfIdQueryGQLType, GetAllComplianceReportCfsByCfIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllComplianceReportCfsByCfIdQueryGQLType, GetAllComplianceReportCfsByCfIdQueryVariablesGQLType>(GetAllComplianceReportCfsByCfIdDocumentGQLType, options);
        }
export type GetAllComplianceReportCfsByCfIdQueryHookResult = ReturnType<typeof useGetAllComplianceReportCfsByCfIdQuery>;
export type GetAllComplianceReportCfsByCfIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAllComplianceReportCfsByCfIdLazyQueryGQLType>;
export type GetAllComplianceReportCfsByCfIdQueryResultGQLType = Apollo.QueryResult<GetAllComplianceReportCfsByCfIdQueryGQLType, GetAllComplianceReportCfsByCfIdQueryVariablesGQLType>;
export const GetComplianceReportCfS3DownloadUrlDocumentGQLType = gql`
    query GetComplianceReportCfS3DownloadUrl($complianceReportId: UUID!) {
  downloadUrl: getComplianceReportCfS3DownloadUrl(
    complianceReportId: $complianceReportId
  )
}
    `;

/**
 * __useGetComplianceReportCfS3DownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetComplianceReportCfS3DownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceReportCfS3DownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceReportCfS3DownloadUrlQuery({
 *   variables: {
 *      complianceReportId: // value for 'complianceReportId'
 *   },
 * });
 */
export function useGetComplianceReportCfS3DownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetComplianceReportCfS3DownloadUrlQueryGQLType, GetComplianceReportCfS3DownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComplianceReportCfS3DownloadUrlQueryGQLType, GetComplianceReportCfS3DownloadUrlQueryVariablesGQLType>(GetComplianceReportCfS3DownloadUrlDocumentGQLType, options);
      }
export function useGetComplianceReportCfS3DownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetComplianceReportCfS3DownloadUrlQueryGQLType, GetComplianceReportCfS3DownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComplianceReportCfS3DownloadUrlQueryGQLType, GetComplianceReportCfS3DownloadUrlQueryVariablesGQLType>(GetComplianceReportCfS3DownloadUrlDocumentGQLType, options);
        }
export type GetComplianceReportCfS3DownloadUrlQueryHookResult = ReturnType<typeof useGetComplianceReportCfS3DownloadUrlQuery>;
export type GetComplianceReportCfS3DownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetComplianceReportCfS3DownloadUrlLazyQueryGQLType>;
export type GetComplianceReportCfS3DownloadUrlQueryResultGQLType = Apollo.QueryResult<GetComplianceReportCfS3DownloadUrlQueryGQLType, GetComplianceReportCfS3DownloadUrlQueryVariablesGQLType>;
export const GetReportingTemplateDownloadUrlDocumentGQLType = gql`
    query GetReportingTemplateDownloadUrl($creditFacilityId: UUID!, $templateName: String!, $s3Path: String!) {
  downloadUrl: getReportingTemplateDownloadUrl(
    creditFacilityId: $creditFacilityId
    templateName: $templateName
    s3Path: $s3Path
  )
}
    `;

/**
 * __useGetReportingTemplateDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetReportingTemplateDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingTemplateDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingTemplateDownloadUrlQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      templateName: // value for 'templateName'
 *      s3Path: // value for 's3Path'
 *   },
 * });
 */
export function useGetReportingTemplateDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>(GetReportingTemplateDownloadUrlDocumentGQLType, options);
      }
export function useGetReportingTemplateDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>(GetReportingTemplateDownloadUrlDocumentGQLType, options);
        }
export type GetReportingTemplateDownloadUrlQueryHookResult = ReturnType<typeof useGetReportingTemplateDownloadUrlQuery>;
export type GetReportingTemplateDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportingTemplateDownloadUrlLazyQueryGQLType>;
export type GetReportingTemplateDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>;
export const InsertNewReportingTemplateDocumentGQLType = gql`
    mutation InsertNewReportingTemplate($creditFacilityId: UUID!, $baseOutputFilename: String!, $reportType: ReportConfigType!, $templateName: String!, $s3Path: String!) {
  newTemplate: insertNewReportingTemplate(
    creditFacilityId: $creditFacilityId
    baseOutputFilename: $baseOutputFilename
    reportType: $reportType
    templateName: $templateName
    s3Path: $s3Path
  ) {
    id
    creditFacilityId
    templateName
    isActive
    reportType
    s3Path
    baseOutputFilename
    created_at
    updated_at
  }
}
    `;
export type InsertNewReportingTemplateMutationFnGQLType = Apollo.MutationFunction<InsertNewReportingTemplateMutationGQLType, InsertNewReportingTemplateMutationVariablesGQLType>;

/**
 * __useInsertNewReportingTemplateMutation__
 *
 * To run a mutation, you first call `useInsertNewReportingTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewReportingTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewReportingTemplateMutation, { data, loading, error }] = useInsertNewReportingTemplateMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      baseOutputFilename: // value for 'baseOutputFilename'
 *      reportType: // value for 'reportType'
 *      templateName: // value for 'templateName'
 *      s3Path: // value for 's3Path'
 *   },
 * });
 */
export function useInsertNewReportingTemplateMutation(baseOptions?: Apollo.MutationHookOptions<InsertNewReportingTemplateMutationGQLType, InsertNewReportingTemplateMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNewReportingTemplateMutationGQLType, InsertNewReportingTemplateMutationVariablesGQLType>(InsertNewReportingTemplateDocumentGQLType, options);
      }
export type InsertNewReportingTemplateMutationHookResult = ReturnType<typeof useInsertNewReportingTemplateMutation>;
export type InsertNewReportingTemplateMutationResultGQLType = Apollo.MutationResult<InsertNewReportingTemplateMutationGQLType>;
export type InsertNewReportingTemplateMutationOptionsGQLType = Apollo.BaseMutationOptions<InsertNewReportingTemplateMutationGQLType, InsertNewReportingTemplateMutationVariablesGQLType>;
export const CreateComplianceReportCfRecordDocumentGQLType = gql`
    mutation CreateComplianceReportCfRecord($creditAgreementId: UUID, $creditFacilityId: UUID!, $reportName: String!, $reportType: ComplianceReportCfType!, $reportingDate: FullDateStr!, $version: Int!, $isPreview: Boolean!, $database: Database!, $namespace: String!, $identifier: String!) {
  createComplianceReportCfRecord(
    creditAgreementId: $creditAgreementId
    creditFacilityId: $creditFacilityId
    reportName: $reportName
    reportType: $reportType
    reportingDate: $reportingDate
    version: $version
    isPreview: $isPreview
    database: $database
    namespace: $namespace
    identifier: $identifier
  ) {
    id
    creditFacilityId
    creditAgreementId
    reportName
    reportType
    reportingDate
    version
  }
}
    `;
export type CreateComplianceReportCfRecordMutationFnGQLType = Apollo.MutationFunction<CreateComplianceReportCfRecordMutationGQLType, CreateComplianceReportCfRecordMutationVariablesGQLType>;

/**
 * __useCreateComplianceReportCfRecordMutation__
 *
 * To run a mutation, you first call `useCreateComplianceReportCfRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceReportCfRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceReportCfRecordMutation, { data, loading, error }] = useCreateComplianceReportCfRecordMutation({
 *   variables: {
 *      creditAgreementId: // value for 'creditAgreementId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportName: // value for 'reportName'
 *      reportType: // value for 'reportType'
 *      reportingDate: // value for 'reportingDate'
 *      version: // value for 'version'
 *      isPreview: // value for 'isPreview'
 *      database: // value for 'database'
 *      namespace: // value for 'namespace'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useCreateComplianceReportCfRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateComplianceReportCfRecordMutationGQLType, CreateComplianceReportCfRecordMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateComplianceReportCfRecordMutationGQLType, CreateComplianceReportCfRecordMutationVariablesGQLType>(CreateComplianceReportCfRecordDocumentGQLType, options);
      }
export type CreateComplianceReportCfRecordMutationHookResult = ReturnType<typeof useCreateComplianceReportCfRecordMutation>;
export type CreateComplianceReportCfRecordMutationResultGQLType = Apollo.MutationResult<CreateComplianceReportCfRecordMutationGQLType>;
export type CreateComplianceReportCfRecordMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateComplianceReportCfRecordMutationGQLType, CreateComplianceReportCfRecordMutationVariablesGQLType>;
export const ProduceReportingGenerateMessageDocumentGQLType = gql`
    mutation ProduceReportingGenerateMessage($worklease: ReportingGenerateWorklease!) {
  result: produceReportingGenerateMessage(worklease: $worklease) {
    status
  }
}
    `;
export type ProduceReportingGenerateMessageMutationFnGQLType = Apollo.MutationFunction<ProduceReportingGenerateMessageMutationGQLType, ProduceReportingGenerateMessageMutationVariablesGQLType>;

/**
 * __useProduceReportingGenerateMessageMutation__
 *
 * To run a mutation, you first call `useProduceReportingGenerateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProduceReportingGenerateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [produceReportingGenerateMessageMutation, { data, loading, error }] = useProduceReportingGenerateMessageMutation({
 *   variables: {
 *      worklease: // value for 'worklease'
 *   },
 * });
 */
export function useProduceReportingGenerateMessageMutation(baseOptions?: Apollo.MutationHookOptions<ProduceReportingGenerateMessageMutationGQLType, ProduceReportingGenerateMessageMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProduceReportingGenerateMessageMutationGQLType, ProduceReportingGenerateMessageMutationVariablesGQLType>(ProduceReportingGenerateMessageDocumentGQLType, options);
      }
export type ProduceReportingGenerateMessageMutationHookResult = ReturnType<typeof useProduceReportingGenerateMessageMutation>;
export type ProduceReportingGenerateMessageMutationResultGQLType = Apollo.MutationResult<ProduceReportingGenerateMessageMutationGQLType>;
export type ProduceReportingGenerateMessageMutationOptionsGQLType = Apollo.BaseMutationOptions<ProduceReportingGenerateMessageMutationGQLType, ProduceReportingGenerateMessageMutationVariablesGQLType>;
export const GenerateReportingOutputXlsxFileDocumentGQLType = gql`
    mutation GenerateReportingOutputXlsxFile($worklease: ReportingGenerateWorklease!) {
  result: generateReportOutputXlsxFile(worklease: $worklease) {
    status
  }
}
    `;
export type GenerateReportingOutputXlsxFileMutationFnGQLType = Apollo.MutationFunction<GenerateReportingOutputXlsxFileMutationGQLType, GenerateReportingOutputXlsxFileMutationVariablesGQLType>;

/**
 * __useGenerateReportingOutputXlsxFileMutation__
 *
 * To run a mutation, you first call `useGenerateReportingOutputXlsxFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportingOutputXlsxFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportingOutputXlsxFileMutation, { data, loading, error }] = useGenerateReportingOutputXlsxFileMutation({
 *   variables: {
 *      worklease: // value for 'worklease'
 *   },
 * });
 */
export function useGenerateReportingOutputXlsxFileMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportingOutputXlsxFileMutationGQLType, GenerateReportingOutputXlsxFileMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportingOutputXlsxFileMutationGQLType, GenerateReportingOutputXlsxFileMutationVariablesGQLType>(GenerateReportingOutputXlsxFileDocumentGQLType, options);
      }
export type GenerateReportingOutputXlsxFileMutationHookResult = ReturnType<typeof useGenerateReportingOutputXlsxFileMutation>;
export type GenerateReportingOutputXlsxFileMutationResultGQLType = Apollo.MutationResult<GenerateReportingOutputXlsxFileMutationGQLType>;
export type GenerateReportingOutputXlsxFileMutationOptionsGQLType = Apollo.BaseMutationOptions<GenerateReportingOutputXlsxFileMutationGQLType, GenerateReportingOutputXlsxFileMutationVariablesGQLType>;